<app-mu-section-title icon="fa fa-fw fa-list-ul"></app-mu-section-title>
<app-parametrizacion
  [flags]="flags"
  [countryObject]="countries"
  [selCountry]="selectedCountry"
  (requestIdService)="updateIsServiceInitial($event)"
></app-parametrizacion>
